module.exports = __webpack_public_path__ + "img/西瓜2.f450e66b.png";